import toShort from '../../../../services/utils/dateParser';
import { customerLogos } from '../../../../config/staticConfigs';

import css from './CDGeneral.module.css';
import { Link } from 'react-router-dom';

const varStyles = {
    contractStatus: {
        Negotiations: css.gray,
        'Raise requests': css.red,
        'All requests raised': css.orange,
        Completed: css.green,
    },
    documentStatus: {
        New: css.gray,
        Signed: css.green,
        'No contract': css.orange,
        Internal: css.blue,
        Cancelled: css.black,
    },
    paymentStatus: {
        'No payment': css.red,
        'Invoices send': css.orange,
        Alternative: css.blue,
        'Payed partially': css.yellow,
        'Payed in full': css.green,
    },
};

function CDGeneral({ data, toggleModal }) {
    console.log(data);

    // const navigate = useNavigate();

    const logo = customerLogos;


    return (
        <div className={css.general}>
            <h2 className={css.h2}>General</h2>
            <div className={css.details}>
                <div
                    className={css.image}
                    style={{
                        //change to customer logo
                        backgroundImage: `${logo[data?.customerId]}`,
                    }}
                ></div>
                <div>
                    <p>
                        Customer: <strong>{data.customerName}</strong>
                    </p>
                    <p>
                        Contract Date: <strong>{toShort(data.contractDate)}</strong>
                    </p>
                    <p className={varStyles.contractStatus[data.contractStatusTitle]}>
                        Contract Status: <span>{data.contractStatusTitle}</span>
                    </p>
                    <p className={varStyles.documentStatus[data.contractDocumentStatusTitle]}>
                        Document Status: <span>{data.contractDocumentStatusTitle}</span>
                    </p>
                    <p className={varStyles.paymentStatus[data.contractPaymentStatusTitle]}>
                        Payment Status: <span>{data.contractPaymentStatusTitle}</span>
                    </p>
                    <p>{/* Status: <strong>{data.courseStatusName}</strong> */}</p>
                    <button className={css.editButon} onClick={() => toggleModal()}>
                        Edit
                    </button>
                    {/* <button className={css.viewButton} onClick={() => navigate(`/enroll/${data.courseId}`)}>
                            Enroll
                        </button> */}
                </div>
                <div>
                    {/* <p>
                        Contract Amount: <strong>{data.contractTotalAmount} BGN</strong>
                    </p> */}
                    <p>
                        Contrtact request: <strong>{data.contractRequests}</strong>
                    </p>
                    <p>
                        Contract Link: <span> </span>
                        {data.contractLink && (
                            <Link to={data.contractLink} target="_blank" rel="noopener noreferrer">
                                <button className={css.viewButton}>View</button>
                            </Link>
                        )}
                    </p>
                    {/* <p>
                            Course Notes: {data.contractNotes}
                        </p> */}
                    <p className={css.comments} style={{ fontSize: '1rem' }}>
                        <strong>Comments:</strong>
                        <br />
                        {data.contractNotes}
                    </p>
                </div>
            </div>
        </div>
    );
}

export default CDGeneral;
export { varStyles };
